module.exports = __webpack_public_path__ + "media/images/sports_icons/027-hockey-stick-8ef24cfa36551f09123a3c05fc9a133a.png";